module.exports = __webpack_public_path__ + "img/akamai.48e0717f.svg";